import React from 'react'
import { Route, Switch } from 'react-router'
import List from './routes/List/index'
import Detail from './routes/Detail/index'
import Form from './routes/Form/index'

export default function RecordingViews () {
  return (
    <Switch>
      <Route exact path='/recordings' component={List} />
      <Route path='/recordings/add' component={Form} />
      <Route path='/recordings/:id' component={Detail} />
    </Switch>
  )
}
